(function () {
  var root = document.querySelector(".cp-checker"); if (!root) return;
  var form = root.querySelector("form"), input = root.querySelector("input"), button = root.querySelector("button"),
      out = root.querySelector(".cp-checker-result");
  var CLOSED = []; try { CLOSED = JSON.parse(root.getAttribute("data-disabled") || "[]"); } catch (e) { CLOSED = []; }
  var ZIP = /^\d{5}(?:-?\d{4})?$/, CA = /^[A-Za-z]\d[A-Za-z]\s?\d[A-Za-z]\d$/;
  var XMAS_EVE = "2026-12-24";
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function show(cls, html) { out.className = "cp-checker-result" + (cls ? " " + cls : ""); out.innerHTML = html; out.hidden = false; }
  function today() {
    var p = new Intl.DateTimeFormat("en-US", { timeZone: "America/New_York", year: "numeric", month: "2-digit", day: "2-digit" }).formatToParts(new Date()), o = {};
    p.forEach(function (x) { o[x.type] = x.value; });
    return o.year + "-" + o.month + "-" + o.day;
  }
  function christmas() {
    var now = today();
    if (now > XMAS_EVE) return " Christmas Eve has passed for this year; the gift's page still lists the next date it can offer.";
    if (CLOSED.indexOf(XMAS_EVE) >= 0) return " <strong>For Christmas:</strong> Thursday, December 24 is not on offer this year, so pick a date before it.";
    return " <strong>For Christmas:</strong> December 25, 2026 is a Friday and nothing is delivered that day, so look for Thursday, December 24 or an earlier date in the gift's date picker.";
  }
  var SAME = " Same-day delivery runs only in New York City, Los Angeles and Northern New Jersey, and only where checkout offers it.";
  function fallback() {
    show("is-warn", "<strong>The ZIP code could not be looked up just now.</strong> Open the gift you have in mind and choose the date on its page: the dates offered there already account for the address.");
  }
  form.addEventListener("submit", function (ev) {
    ev.preventDefault();
    var raw = String(input.value || "").trim(), code = raw.replace(/\s+/g, "");
    if (CA.test(code)) { show("is-warn", "<strong>" + esc(raw.toUpperCase()) + " is a Canadian postal code.</strong> International delivery is not offered, so a gift from this store cannot go to an address outside the United States."); return; }
    if (!ZIP.test(code)) { show("is-error", "Type the recipient's five-digit ZIP code, for example <strong>10001</strong>."); input.focus(); return; }
    var zip = code.slice(0, 5);
    if (button) button.disabled = true;
    show("", "Looking up " + zip + " ...");
    var ctl = typeof AbortController === "function" ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctl) ctl.abort(); }, 18000);
    fetch("/a/multi/checkAddress", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ postcode: zip, postal_code: zip, country: "US" }),
      signal: ctl ? ctl.signal : undefined
    }).then(function (r) {
      if (!r.ok) throw new Error("lookup");
      return r.json();
    }).then(function (payload) {
      var a = payload && payload.data && payload.data.resultAddressByPostalCode;
      if (!payload || payload.status !== 200 || !a || !a.city || a.country !== "US") throw new Error("lookup");
      show("", "<strong>" + zip + ": " + esc(a.city) + (a.state ? ", " + esc(a.state) : "") + ".</strong>"
        + " Open the gift and pick the date on its page. This lookup only places the ZIP code; it does not confirm that a gift is in stock, the arrival date or the final charge."
        + christmas() + SAME);
    }).catch(fallback).then(function () {
      clearTimeout(timer);
      if (button) button.disabled = false;
    });
  });
})();